import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasNodeToolbarActionClicked.meta';

export type UseTrackCanvasNodeToolbarActionClickedParams = {
  canvas_id: string;
  node_type: 'image' | 'video';
  action_taken:
    | 'adjust_image'
    | 'camera_angle'
    | 'camera_motion'
    | 'change_lighting'
    | 'smart_resize'
    | 'crop'
    | 'prompt'
    | 'edit_text'
    | 'flip_and_rotate'
    | 'erase'
    | 'extend_background'
    | 'remove_background'
    | 'upscale'
    | 'convert_to_gif'
    | 'animate'
    | 'animate_surprise_me'
    | 'extend_video'
    | 'extend_video_surprise_me'
    | 'vectorize'
    | 'translate'
    | 'split_elements';
  variant_count?: number;
};

export const useTrackCanvasNodeToolbarActionClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasNodeToolbarActionClicked = useCallback(
    (params: UseTrackCanvasNodeToolbarActionClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasNodeToolbarActionClicked };
};
